import { render, staticRenderFns } from "./OtherSelect.vue?vue&type=template&id=748a79a3&scoped=true"
import script from "./OtherSelect.vue?vue&type=script&lang=ts"
export * from "./OtherSelect.vue?vue&type=script&lang=ts"
import style0 from "./OtherSelect.vue?vue&type=style&index=0&id=748a79a3&prod&scoped=true&lang=less"
import style1 from "./OtherSelect.vue?vue&type=style&index=1&id=748a79a3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748a79a3",
  null
  
)

export default component.exports